import { axiosHelper } from 'Services/AxiosHelper';
import { OnCheckPhoneNumberModel } from 'Models';
import { onCheckPhoneNumberBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnCheckPhoneNumber';

const onCheckPhoneNumber = async ({
  CountryCode,
  Cellphone,
}: onCheckPhoneNumberBodyData): Promise<OnCheckPhoneNumberModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: { CountryCode, Cellphone },
    })
  ).data;

export default onCheckPhoneNumber;
